<div class="gradient-text-wrapper">
    <div class="gradient-text">
        <ng-content></ng-content>
    </div>
</div>
